// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ltp41F {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  flex: 1;
  min-height: 104px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #e5e5e5);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  gap: 16px;
}

.Ltp41F:hover {
  background: var(--surface-primary-hover, #f5f5f5);
  transform: translateY(-2px);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
}

.Zm_IKR {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: transparent;
}

._PePu4 {
  width: 16px;
  height: 16px;
  color: var(--brand-primary, #d64000);
}

.JxGk3W {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--text-primary, #1f1f1f);
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  margin: 0;
}

/* Tablet styles */
@media (max-width: 768px) {
  .Ltp41F {
    width: 160px;
    min-height: 96px;
    padding: 14px;
    gap: 14px;
  }
}

/* Mobile styles */
@media (max-width: 480px) {
  .Ltp41F {
    width: 100%;
    min-height: 88px;
    padding: 12px;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixCopyPasteCard/PixCopyPasteCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;AACF","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px;\n  flex: 1;\n  min-height: 104px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #e5e5e5);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);\n  box-sizing: border-box;\n  gap: 16px;\n}\n\n.card:hover {\n  background: var(--surface-primary-hover, #f5f5f5);\n  transform: translateY(-2px);\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  background: transparent;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  color: var(--brand-primary, #d64000);\n}\n\n.title {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: var(--text-primary, #1f1f1f);\n  text-align: left;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  margin: 0;\n}\n\n/* Tablet styles */\n@media (max-width: 768px) {\n  .card {\n    width: 160px;\n    min-height: 96px;\n    padding: 14px;\n    gap: 14px;\n  }\n}\n\n/* Mobile styles */\n@media (max-width: 480px) {\n  .card {\n    width: 100%;\n    min-height: 88px;\n    padding: 12px;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Ltp41F`,
	"iconContainer": `Zm_IKR`,
	"icon": `_PePu4`,
	"title": `JxGk3W`
};
module.exports = ___CSS_LOADER_EXPORT___;
